 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A01 from '@/components/001'
 import A02 from '@/components/002'
 import A03 from '@/components/003'
 import A04 from '@/components/004'
 import A05 from '@/components/005'
 import A06 from '@/components/006'
 import A07 from '@/components/007'
 import A08 from '@/components/008'
 import A09 from '@/components/009'
 import A10 from '@/components/010'
 import A11 from '@/components/011'
 import A12 from '@/components/012'
 import A13 from '@/components/013'
 import A14 from '@/components/014'
 import A15 from '@/components/015'
 import A16 from '@/components/016'
 import A17 from '@/components/017'
 import A18 from '@/components/018'
 import A19 from '@/components/019'
 import A20 from '@/components/020'
 import A21 from '@/components/021'
 import A22 from '@/components/022'
 import A23 from '@/components/023'
 import A24 from '@/components/024'
 import A25 from '@/components/025'
 import A26 from '@/components/026'
 import A27 from '@/components/027'
 import A28 from '@/components/028'
 import A29 from '@/components/029'
 import A30 from '@/components/030'
 import A31 from '@/components/031'
 import A32 from '@/components/032'
 import A33 from '@/components/033'
 import A34 from '@/components/034'
 import A35 from '@/components/035'
 import A36 from '@/components/036'
 import A37 from '@/components/037'
 import A38 from '@/components/038'
 import A39 from '@/components/039'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/001",
 			"name" : "001",
 			"component" : A01
 		},
 		{
 			"path" : "/002",
 			"name" : "002",
 			"component" : A02
 		},
 		{
 			"path" : "/003",
 			"name" : "003",
 			"component" : A03
 		},
 		{
 			"path" : "/004",
 			"name" : "004",
 			"component" : A04
 		},
 		{
 			"path" : "/005",
 			"name" : "005",
 			"component" : A05
 		},
 		{
 			"path" : "/006",
 			"name" : "006",
 			"component" : A06
 		},
 		{
 			"path" : "/007",
 			"name" : "007",
 			"component" : A07
 		},
 		{
 			"path" : "/008",
 			"name" : "008",
 			"component" : A08
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js